import angular from 'angular';
import Navbar from './navbar/navbar';
import Footer from './footer/footer';
import Home from './home/home';
import About from './about/about';
import Services from './services/services';
import Careers from './careers/careers';
import News from './news/news';
import Article from './article/article';
import Contact from './contact/contact';
import Referral from './referral/referral';
import Jobs from './jobs/jobs';
import JobDetails from './jobDetails/jobDetails';

let componentModule = angular.module('app.components', [
  Navbar.name,
  Footer.name,
  Home.name,
  About.name,
  Services.name,
  Careers.name,
  News.name,
  Article.name,
  Contact.name,
  Referral.name,
  Jobs.name,
  JobDetails.name
]);

export default componentModule;



// WEBPACK FOOTER //
// ./app/components/components.js